<template>
    <div class="[ bg-gray-pale ]">
        <Teleport to="[data-breadcrumb]" v-if="isMounted">
            <div class="[ flex items-center gap-2 text-sm text-gray-dark ]">
                <RouterLink :to="{ name: 'scorecard-templates' }">
                    <div class="[ flex gap-1 items-center ]">
                        <JBIcon name="chevron-left" />
                        All Scorecard templates
                    </div>
                </RouterLink>
                <div class="[ text-gray-dark ]">/ {{ name || 'New scorecard Template' }}</div>
            </div>
        </Teleport>
        <Teleport to="[data-header-action]" v-if="isMounted">
            <div class="[ flex gap-2 items-center ]">
                <SplitButton label="Create as Draft" :loading="loading" @click="createAndRedirect" :model="items" />
            </div>
        </Teleport>
        <div>
            <GridForm size="large">
                <GridFormField id="name" label="Name">
                    <template #input="{ id }">
                        <InputText :id="id" v-model="name" />
                    </template>
                </GridFormField>
                <GridFormField id="parameters" label="Parameters">
                    <template #input>
                        <MonacoEditor v-model="parameters" language="json" class="[ h-96 ]" :libs="{}" />
                    </template>
                </GridFormField>
            </GridForm>
        </div>
    </div>
</template>
<script setup lang="ts">
import { definePage, useRouter } from 'vue-router/auto'
import { InputText, SplitButton } from "primevue";
import { useApi, useApiLoader } from '@/services/api';
import { ref } from 'vue';
import GridForm from '@/components/ui/GridForm.vue';
import GridFormField from '@/components/ui/GridFormField.vue';
import { useMounted } from '@vueuse/core';
import MonacoEditor from '@/components/ui/MonacoEditor.vue';
import { MenuItem } from 'primevue/menuitem';

const router = useRouter();

const name = ref<string>('');
const parameters = ref<string>('[]');
const isDraft = ref(true);

const items: MenuItem[] = [{
    label: 'Create',
    async command() {
        isDraft.value = false;
        await createAndRedirect();
    },
}];

const isMounted = useMounted();

const api = useApi();

const { load: createScorecardTemplate, loading } = useApiLoader(async () => {
    const res = await api.createScorecardTemplate({
        createScorecardTemplateRequest: {
            name: name.value,
            parameters: parameters.value,
            isDraft: isDraft.value,
        },
    });

    return res.data;
}, null);

async function createAndRedirect() {
    await createScorecardTemplate();
    router.back();
}

definePage({
    name: "new-scorecard-template",
    meta: { title: "New Scorecard Template", icon: "hierarchy-square" },
});
</script>